<div *ngIf="details$ | async as request">
	<div class="flex justify-between items-center mb-4">
		<div class="flex flex-col gap-2">
			<p class="p-sm">
				<span class="font-medium">Request Id:</span> {{ request.id }}
			</p>
			<div
				class="px-3 py-1.5 rounded-md inline-block border"
				[ngClass]="{
					'bg-amber-50 text-amber-800 border-amber-200':
						request.status === DocumentRequestStatus.Pending,
					'bg-blue-50 text-blue-800 border-blue-200':
						request.status === DocumentRequestStatus.InProgress,
					'bg-green-50 text-green-800 border-green-200':
						request.status === DocumentRequestStatus.Completed,
					'bg-red-50 text-red-800 border-red-200':
						request.status === DocumentRequestStatus.Canceled,
					'bg-gray-50 text-gray-800 border-gray-200':
						request.status === DocumentRequestStatus.OnHold,
				}"
			>
				<p class="text-xs">{{ request.status | titlecase }}</p>
			</div>
		</div>
		<div class="text-right">
			<p class="text-sm text-gray-950">
				{{ request.createdAt | date: 'mediumDate' }}
			</p>
			<p class="text-xs text-gray-600">
				{{ request.createdAt | date: 'shortTime' }}
			</p>
		</div>
	</div>

	<div class="mt-5">
		<h4 class="h4">Documents ({{ request.documents.length }})</h4>
		<div class="flex flex-col gap-3">
			<div
				*ngFor="let doc of request.documents"
				class="flex items-center py-3 px-4 border border-gray-200 hover:bg-gray-50 duration-300 rounded-lg gap-3 cursor-pointer"
				(click)="previewDocument(doc)"
			>
				<div class="text-xl text-gray-600">
					<i-tabler
						[name]="
							doc.contentType.includes('pdf')
								? 'file-type-pdf'
								: 'file-type-docx'
						"
						class="w-4 h-4"
					></i-tabler>
				</div>
				<div class="flex-1">
					<div class="font-medium">{{ doc.name }}</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="request.note" class="mt-5 pt-5 border-t border-gray-200">
		<h3 class="text-lg font-medium text-gray-900 mb-2">Notes</h3>
		<p class="text-gray-600 leading-relaxed">{{ request.note }}</p>
	</div>

	<div class="mt-5" *ngIf="canMakeRequests()">
		<div class="flex flex-col gap-3 items-end">
			<button
				class="px-3 py-1.5 text-sm rounded-md bg-red-50 text-red-600 duration-300 hover:bg-red-200 border border-red-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-red-50"
				(click)="cancelRequest()"
				[disabled]="
					request.internalStatus !== DocumentRequestStatus.PENDING ||
					request.status === DocumentRequestStatus.CANCELED
				"
			>
				Cancel Request
			</button>
		</div>
	</div>
</div>
